import { Controller } from 'stimulus'

// <button data-controller="back" data-action="click->back#goBack">Go Back</button>
export default class extends Controller {
  goBack() {
    window.history.back();
  }
}
